import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import axios from '~/data/http/axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import i18n from '~/i18n'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import PermissionChecker from '~/Classes/permissions'

import AddEvent from './addEvent'
import DeleteEvent from './deleteEvent'

import Graph from './graph'

@connect((store) => {
    return {
        user: store.user,
        permissionStore: store.permission,
        siteMaster: store.siteMaster,
        accountMaster: store.accountMaster
    }
})
export default class ViewCampaigns extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            events: [],
            tableData: [],
            loadingData: true,
            graphData: [],
            writeAccess: PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        }
        this.getEvents = this.getEvents.bind(this)
        this.addEvent = this.addEvent.bind(this)
        this.addedEvent = this.addedEvent.bind(this)
        this.deleteEvent = this.deleteEvent.bind(this)
    }

    componentDidMount() {
        this.getEvents()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.startDate != this.props.startDate || prevProps.endDate != this.props.endDate) {
            this.setState({ loadingData: 1 }, () => {
                this.getEvents()
            })
        }
    }

    async getEvents() {
        this.setState({ loadingData: true })
        let events = await axios.get(
            `/accountMaster/tracker/events/${this.props.tracker.id}?startDate=${this.props.startDate.format('YYYY-MM-DD')}&endDate=${this.props.endDate.format('YYYY-MM-DD')}`
        )
        let tableData = events.data.map((row) => {
            return [
                {
                    headerValue: 'Id',
                    value: row.id,
                    width: 40
                },
                {
                    headerValue: 'Event',
                    value: <strong>{row.name}</strong>
                },
                {
                    headerValue: 'Hits',
                    value: row.hits
                },
                {
                    headerValue: 'Value',
                    value: row.value
                        ? this.props.accountMaster.accountMaster.currencySymbol +
                          NumberFunctions.formatNumber(row.value, 2)
                        : ''
                },
                {
                    headerValue: 'Values Available',
                    value: row.detectedValues
                        ? row.detectedValues.map((m) => {
                              return <SquareChip className='mar-r5 mar-b5'>{m.name}</SquareChip>
                          })
                        : ''
                },
                {
                    headerValue: '',
                    value: row.system ? (
                        <>
                            <SquareChip>System</SquareChip>
                        </>
                    ) : (
                        this.state.writeAccess && (
                            <Icons
                                icon='bin'
                                color='#FF0000'
                                onClick={() => {
                                    this.deleteEvent(row)
                                }}
                            />
                        )
                    ),
                    width: 50,
                    align: 'center'
                }
            ]
        })

        let graphData = await axios.get(
            `/accountMaster/tracker/events/${this.props.tracker.id}/graph?startDate=${this.props.startDate.format('YYYY-MM-DD')}&endDate=${this.props.endDate.format('YYYY-MM-DD')}`
        )

        graphData = graphData.data.map((row) => {
            row.date = DateTimeFunctions.formatDateTime(row.date, 2)
            return row
        })
        this.setState({ tableData, loadingData: false, events: events.data, graphData: graphData })
    }

    addEvent() {
        if (!this.state.writeAccess) return
        var drawerContent = <AddEvent tracker={this.props.tracker} close={this.addedEvent} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }

    addedEvent() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
        this.getEvents()
    }

    deleteEvent(event) {
        var drawerContent = <DeleteEvent tracker={this.props.tracker} event={event} close={this.addedEvent} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }
    render() {
        if (this.state.loadingData == false && this.state.events.length <= 0) {
            return (
                <>
                    <Paper>
                        <h4 className='mar-b10'>You haven't added any events yet</h4>
                        <div className='mar-b25'>
                            You can use events to track when visitors do something on your website. For example
                            registering.
                        </div>
                        <Button
                            text='Add your first Event'
                            onClick={this.addEvent}
                            disabled={!this.state.writeAccess}
                            tooltip={!this.state.writeAccess ? "You don't have permission to do this" : ''}
                            for={'addEventBtn'}
                        />
                    </Paper>
                </>
            )
        }

        var visBetTxt = i18n.t('campaigns:sitetracking.trackingoverview.visitorsBetween')
        visBetTxt = visBetTxt.replace(/\[DATE1\]/g, DateTimeFunctions.formatDateTime(this.props.startDate, 2))
        visBetTxt = visBetTxt.replace(/\[DATE2\]/g, DateTimeFunctions.formatDateTime(this.props.endDate, 2))

        return (
            <>
                <Row>
                    <Column xs={12} margin={0}>
                        <Paper>
                            <p className='text-grey text-sml'>{visBetTxt}</p>
                            <Graph graphData={this.state.graphData} height={200} />
                        </Paper>
                    </Column>
                    <Column xs={12} margin={0}>
                        <Paper>
                            <div className='text-right mar-b25'>
                                <Button
                                    iconLeft={<Icons icon='plus' />}
                                    text='Add an Event'
                                    onClick={this.addEvent}
                                    tooltip={!this.state.writeAccess ? "You don't have permission to do this" : ''}
                                    for={'addSiteBtn2'}
                                    disabled={!this.state.writeAccess}
                                />
                            </div>
                            <DataTable1
                                noResultsTxt={i18n.t('campaigns:sitetracking.trackingvistors.noDataFound')}
                                tableData={this.state.tableData}
                                dataUpdater={() => {}}
                                width='100%'
                                pageSize='100'
                                hasCheckBoxes='no'
                                sortedColumn={''}
                                sortedDirection={''}
                                loadingData={this.state.loadingData}
                            />
                        </Paper>
                    </Column>
                </Row>
            </>
        )
    }
}
